import styled from "styled-components";

// Card shell
export const Card = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e9eaeb;
  border-radius: 12px;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  background: #fff;
  width: 100%;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: #ffffff;
  border-bottom: 1px solid #e9eaeb;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const SubtitleText = styled.p`
  margin: 0;
  color: #535862;
  font-size: 14px;
`;

export const CardContent = styled.div`
  background: #fff;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

// Strategy tabs
export const StrategyTabsContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 16px 20px 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 768px) {
    gap: 0.25rem;
  }
`;

export const StrategyTab = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  background-color: ${({ $isActive }) =>
    $isActive ? "#f9fafb" : "transparent"};
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  flex-shrink: 0;
  white-space: nowrap;

  @media (max-width: 768px) {
    padding: 0.25rem 0.5rem;
    font-size: 11px;
  }
`;

export const StrategyIcon = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
`;

export const StrategyLogo = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #e5e7eb;
  display: ${({ $hidden }) => ($hidden ? "none" : "flex")};
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
  color: #6b7280;
`;

export const Divider = styled.div`
  border-top: 1px solid #e9eaeb;
  margin: 16px 20px 0;
`;

// Industry view — treemap + legend table
export const ContentContainer = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: 1400px) {
    flex-direction: column;
  }

  @media (max-width: 768px) {
    gap: 16px;
  }
`;

export const TreemapContainer = styled.div`
  position: relative;
  flex: 1;
  min-width: 0;
  height: 420px;
  background-color: #f9fafb;
  border: 1px solid #e9eaeb;
  border-radius: 8px;
  overflow: hidden;

  @media (max-width: 768px) {
    flex: none;
    width: 100%;
    height: 260px;
  }
`;

export const TreemapRectangle = styled.div`
  position: absolute;
  left: ${({ $left }) => $left}%;
  top: ${({ $top }) => $top}%;
  width: ${({ $width }) => $width}%;
  height: ${({ $height }) => $height}%;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  box-sizing: border-box;
`;

export const RectangleName = styled.span`
  font-size: ${({ $fontSize }) => $fontSize || "0.8rem"};
  font-weight: 500;
  color: ${({ $textColor }) => $textColor || "#111827"};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 90%;
`;

export const RectanglePercentage = styled.span`
  font-size: ${({ $fontSize }) => $fontSize || "0.75rem"};
  font-weight: 600;
  color: ${({ $textColor }) => $textColor || "#374151"};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 90%;
`;

export const TableContainer = styled.div`
  flex: 0 0 300px;
  border-radius: 8px;
  background: #fff;
  padding: 16px;

  @media (max-width: 1400px) {
    flex: 0 0 auto;
    width: 100%;
    padding: 0;
  }
`;

export const TableHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #e9eaeb;
  margin-bottom: 8px;
`;

export const TableRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #e9eaeb;

  &:last-child {
    border-bottom: none;
  }
`;

export const TableRowLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ColorIndicator = styled.div`
  width: 12px;
  height: 28px;
  border-radius: 10px;
  background-color: ${({ $color }) => $color || "#6b7280"};
  border: ${({ $needsBorder }) =>
    $needsBorder ? "1px solid #cbd5e1" : "none"};
  flex-shrink: 0;
`;

export const IndustryName = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #181d27;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 180px;
`;

export const PercentageBadge = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #414651;
  background-color: #fafafa;
  padding: 4px 8px;
  border: 1px solid #e9eaeb;
  border-radius: 6px;
  min-width: 40px;
  text-align: center;
`;

// Assets view
export const AssetsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const AssetTableWrapper = styled.div`
  margin-top: 1rem;
`;

export const AssetLogoContainer = styled.div`
  position: relative;
  width: 32px;
  height: 32px;
`;

export const AssetLogoImage = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #e2e8f0;
  display: block;
`;

export const AssetLogoFallback = styled.div`
  display: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #3b82f6;
  color: #ffffff;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #e2e8f0;
`;

export const AssetCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AssetInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AssetSymbol = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #0f172a;
`;

export const AssetCompany = styled.div`
  font-size: 12px;
  color: #64748b;
`;

export const AssetText = styled.span`
  font-weight: 400;
  color: #0f172a;
`;

export const AssetValueContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AssetValue = styled.div`
  font-weight: 400;
  color: #0f172a;
  font-size: 14px;
`;

export const AssetShares = styled.div`
  font-size: 12px;
  color: #64748b;
`;

export const StrategyBadgesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const StrategyBadge = styled.span`
  border-radius: 4px;
  font-size: 12px;
  color: #475569;
`;

// State messages
export const ErrorText = styled.div`
  color: #ef4444;
  font-size: 14px;
  text-align: center;
  padding: 20px;
`;

export const MessageText = styled.div`
  color: #6b7280;
  font-size: 14px;
  text-align: center;
  padding: 20px;
`;

export const LoadingMessage = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #64748b;
  font-size: 14px;
`;

export const EmptyMessage = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #64748b;
  font-size: 14px;
`;
